/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable consistent-return */
import React, { useState, useRef, useEffect, memo, } from "react";
import { useInView } from "../../hooks";
const isServer = typeof window === "undefined";
function renderPlaceholder(element, ref, placeholderComponent = null, height = 0) {
    return React.createElement(element, { ref, style: { height } }, placeholderComponent);
}
/**
 * Component for lazy rendering of child react components
 */
function LazyRenderComponent({ rootElement, wrapElement = "div", placeholderElement = "div", visibleOffset = 0, idleTimeout = 500, visibleThreshold, placeholderHeight: defaultPlaceholderHeight = 0, lazyBehavior = "keepMounted", placeholderComponent, onChange, children, }) {
    const [isVisible, setIsVisible] = useState(isServer);
    const [isEnabled, setIsEnabled] = useState(!(isVisible && lazyBehavior === "keepMounted"));
    const placeholderHeight = useRef(defaultPlaceholderHeight);
    function handleVisible(isElementVisible) {
        if (isEnabled) {
            if (isElementVisible && lazyBehavior === "keepMounted") {
                setIsEnabled(false);
            }
            setIsVisible(isElementVisible);
            onChange === null || onChange === void 0 ? void 0 : onChange(isElementVisible);
        }
    }
    const { ref: intersectionRef } = useInView({
        onChange: handleVisible,
        rootElement,
        visibleOffset,
        visibleThreshold,
        idleTimeout,
        isEnabled,
    });
    // Set true height for placeholder element after render
    useEffect(() => {
        if (isEnabled && intersectionRef.current) {
            placeholderHeight.current = intersectionRef.current.offsetHeight;
        }
    }, [isEnabled, isVisible, intersectionRef, lazyBehavior]);
    if (!isEnabled) {
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return React.createElement(React.Fragment, null, children);
    }
    const placeholder = renderPlaceholder(placeholderElement, intersectionRef, placeholderComponent, placeholderHeight.current);
    if (!isVisible) {
        return placeholder;
    }
    const childrenWithRef = React.createElement(wrapElement, { ref: intersectionRef }, children);
    return childrenWithRef;
}
export const LazyRender = memo(LazyRenderComponent);
LazyRender.displayName = "LazyRender";
export default LazyRender;
//# sourceMappingURL=LazyRender.js.map